import {CanActivateFn} from '@angular/router';
import {
	adminGuard,
	authGuard,
	emailVerifiedGuard,
	emailVerifiedOrRedirectTo,
	redirectEmailVerifiedTo,
	redirectLoggedInToStorage
} from '@guards';

export const redirectToLanding: CanActivateFn = authGuard(['']);
export const redirectToVerify: CanActivateFn = authGuard(['verify-email']);

export const redirectLoggedInToHome: CanActivateFn = redirectLoggedInToStorage(['app', 'home']);
export const redirectLoggedInToTest: CanActivateFn = redirectLoggedInToStorage(['test']);
export const requireEmailVerified: CanActivateFn = emailVerifiedGuard;
export const requireEmailVerifiedOrPublicTest: CanActivateFn = emailVerifiedOrRedirectTo(['test-bdsm']);
export const redirectVerifiedToHome: CanActivateFn = redirectEmailVerifiedTo(['app', 'home']);
export const requireAdmin: CanActivateFn = adminGuard;
